/*
 * @Author       : 四川华西绿舍建材有限公司
 * @Date         : 2022-06-24 15:53:24
 * @LastEditTime : 2024-03-06 11:46:31
 * @LastEditors  : yangxr
 * @Description  : 
 * @FilePath     : \icps_fb\src\api\smart\schedul\h.js
 */
/*
 * @Description: 
 * @Autor: wangwangwang
 * @Date: 2021-01-20 11:54:04
 * @LastEditors: wangwangwang
 * @LastEditTime: 2021-03-23 14:53:16
 */
import request from '@/utils/request'
export const queryPage = '/icps/system/sign/dataCollection/productPlan/QueryPage'
export const Download = '/icps/system/sign/dataCollection/supplierPlan/exportList'
export const Download1 = '/icps/system/sign/dataCollection/productPlan/exportSupperDetail'
/*新增采购申请*/
export function saveOrUpdate(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/saveOrUpdate',
    method: 'post',
    data
  })
}
/*供应详情*/
export function getPlanDetailById(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/getPlanDetail',
    method: 'post',
    data
  })
}
/*获取计划*/
export function getLotAllotsByStation(data) {
  return request({
    url: '/icps/system/sign/dataCollection/lotMaintain/getLotAllotsByStation',
    method: 'post',
    data
  })
}
/*获取计划*/
export function deletePlan(params) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/deletePlan',
    method: 'get',
    params
  })
}
/*获取车辆合同*/
export function getContractCarByCondition(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contract/getContractCarByCondition',
    method: 'post',
    data
  })
}
/*获取库存缺口量*/
export function inventoryget_gap(data) {
  return request({
    url: '/icps/system/sign/basics/inventory/get_gap',
    method: 'post',
    data
  })
}
/*查询供应商是否分配账号*/
export function getisByContractId(data) {
  return request({
    url: '/icps/system/sign/dataCollection/contractUser/getisByContractId',
    method: 'post',
    data
  })
}
/*根据站点原物料查询主体库存列表*/
export function queryMainBodyStock(data) {
  return request({
    url: '/icps/system/sign/dataCollection/productPlan/queryMainBodyStock',
    method: 'post',
    data
  })
}